import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  
  transform(url: string | null) {
    if (!url) return '';

    let parsedUrl = new URL(url);
    let parsedModules = new URL(environment.modulesPayvalidaUrl);

    if (parsedUrl.hostname == environment.payvalidaHostname || parsedUrl.hostname.endsWith(`.${environment.payvalidaHostname}`) ||  parsedModules.hostname === parsedUrl.hostname) return this.sanitizer.bypassSecurityTrustResourceUrl(url);

    return this.sanitizer.sanitize(SecurityContext.URL, url);
  }
}
